import { type Address, type BillingAddress, type Nullable, type ShippingAddress } from "@common/declarations";

export const mapFromBillingAddress = (address: Partial<Nullable<BillingAddress>>): Partial<Nullable<Address>> => ({
  city: address.billingCity,
  company: address.billingCompany,
  companyTaxNumber: address.billingCompanyTaxNumber,
  countryCode: address.billingCountryCode,
  email: address.billingEmail,
  firstName: address.billingFirstName,
  lastName: address.billingLastName,
  telephone: address.billingTelephone,
  postalCode: address.billingPostalCode,
  street: address.billingStreet,
  subdivisionCode: address.billingSubdivisionCode,
  unit: address.billingUnit,
  latitude: address.billingLatitude,
  longitude: address.billingLongitude
});

export const mapFromShippingAddress = (address: Partial<Nullable<ShippingAddress>>): Partial<Nullable<Address>> => ({
  city: address.shippingCity,
  company: address.shippingCompany,
  companyTaxNumber: null,
  countryCode: address.shippingCountryCode,
  email: address.shippingEmail,
  firstName: address.shippingFirstName,
  lastName: address.shippingLastName,
  telephone: address.shippingTelephone,
  postalCode: address.shippingPostalCode,
  street: address.shippingStreet,
  subdivisionCode: address.shippingSubdivisionCode,
  unit: address.shippingUnit,
  latitude: address.shippingLatitude,
  longitude: address.shippingLongitude
});

export const getIsEmptyAddress = (address: Partial<Nullable<Address>>): boolean => getIsSameAddress(address, {});

export const getIsSameAddress = (
  a: Partial<Nullable<Address>>,
  b: Partial<Nullable<Address>>,
  props: Array<keyof Address> = [
    "city",
    "company",
    "companyTaxNumber",
    "email",
    "firstName",
    "lastName",
    "countryCode",
    "subdivisionCode",
    "postalCode",
    "street",
    "telephone",
    "unit"
  ]
): boolean => {
  const equal = (x: any, y: any) => (x || "") == (y || "");

  return props.every((x) => equal(a[x], b[x]));
};

export const mapToBillingAddress = (address: Partial<Nullable<Address>>): Partial<Nullable<BillingAddress>> => ({
  billingCity: address.city,
  billingCompany: address.company,
  billingCompanyTaxNumber: address.companyTaxNumber,
  billingCountryCode: address.countryCode,
  billingEmail: address.email,
  billingFirstName: address.firstName,
  billingLastName: address.lastName,
  billingTelephone: address.telephone,
  billingPostalCode: address.postalCode,
  billingStreet: address.street,
  billingSubdivisionCode: address.subdivisionCode,
  billingUnit: address.unit
});

export const mapToShippingAddress = (address: Partial<Nullable<Address>>): Partial<Nullable<ShippingAddress>> => ({
  shippingCity: address.city,
  shippingCompany: address.company,
  shippingCountryCode: address.countryCode,
  shippingEmail: address.email,
  shippingFirstName: address.firstName,
  shippingLastName: address.lastName,
  shippingTelephone: address.telephone,
  shippingPostalCode: address.postalCode,
  shippingStreet: address.street,
  shippingSubdivisionCode: address.subdivisionCode,
  shippingUnit: address.unit,
  shippingLatitude: address.latitude,
  shippingLongitude: address.longitude
});
